"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="../common/Window.d.ts" />
var fvp_utils_1 = require("@digital-uk/fvp-utils");
require("promise-polyfill/src/polyfill");
var polyfillArrayFind_1 = require("../common/utils/browser/polyfillArrayFind");
// eslint-disable-next-line @typescript-eslint/no-require-imports
var deviceConfig = require("../device/deviceConfig.json");
var getDeviceClass_1 = require("./func/getDeviceClass");
function attachScriptElement(src) {
    var script = document.createElement('script');
    script.src = src;
    document.head.appendChild(script);
    return script;
}
function loadApp() {
    try {
        var device = (0, fvp_utils_1.getFVPDevice)(window.navigator.userAgent, 'lcn');
        var deviceClass = (0, getDeviceClass_1.getDeviceClass)(device.id, deviceConfig);
        window.deviceConfig = deviceConfig;
        window.device = device;
        attachScriptElement("".concat(deviceClass, ".js"));
    }
    catch (e) {
        console.error(e);
    }
}
window.onload = function () {
    (0, polyfillArrayFind_1.polyfillArrayFind)();
    // eslint-disable-next-line no-console
    console.log("bootstrap running: ".concat(window.navigator.userAgent));
    if (typeof window.oipfObjectFactory === 'undefined') {
        var script = attachScriptElement('fakes.js');
        script.onload = function () { return loadApp(); };
    }
    else {
        loadApp();
    }
};
